export default function PieChartIcon2({ className }) {
  return (<>
    <svg width="23" height="22" viewBox="0 0 23 22"
      className={className}
      fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_804_1845)">
        <path d="M11.4997 20.1668C6.43692 20.1668 2.33301 16.0629 2.33301 11.0002C2.33301 6.89533 5.03076 3.42116 8.74967 2.25333V4.20033C7.17385 4.8402 5.86932 6.00773 5.05923 7.50319C4.24913 8.99864 3.98382 10.7291 4.30866 12.3986C4.6335 14.068 5.52832 15.5728 6.84004 16.6554C8.15177 17.738 9.7989 18.3312 11.4997 18.3335C12.9606 18.3335 14.3883 17.8972 15.5998 17.0806C16.8112 16.2641 17.7513 15.1044 18.2995 13.7502H20.2465C19.0787 17.4691 15.6045 20.1668 11.4997 20.1668ZM20.6205 11.9168H10.583V1.87933C10.8846 1.84908 11.1908 1.8335 11.4997 1.8335C16.5624 1.8335 20.6663 5.93741 20.6663 11.0002C20.6663 11.3091 20.6508 11.6152 20.6205 11.9168ZM12.4163 3.72366V10.0835H18.7762C18.5721 8.46797 17.8365 6.96622 16.685 5.81479C15.5336 4.66337 14.0319 3.9277 12.4163 3.72366Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_804_1845">
          <rect width="22" height="22" fill="currentColor" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>

  </>)
}